import { pickBy } from '@/utils'
import AttrGoods from './attr-goods'
import CompPickerLink from '../../comps/comp-pickerLink'

export default {
  name: 'goodsGrid',
  setting: [
    { label: '標題', key: 'title', component: 'input', value: '爆品直郵' },
    { label: '副標題', key: 'subtitle', component: 'input', value: '宅家買遍全法' },
    { label: '組件間距', key: 'padded', component: 'switch', value: true },
    {
      label: '樣式',
      key: 'style',
      component: 'radio',
      options: [
        { name: '一行兩個', label: 'grid' },
        { name: '一行三個', label: 'grids' }
      ],
      value: 'grid'
    },
    { label: '顯示價格', key: 'showPrice', component: 'switch', value: false },
    { label: '顯示品牌', key: 'brand', component: 'switch', value: true },
    {
      label: '選擇商品',
      key: 'data',
      component: function (h, { key }) {
        return <AttrGoods v-model={this.value[key]} />
      },
      value: [
        {
          imgUrl: '',
          linkPage: '',
          content: '',
          title: '商品名稱',
          id: '',
          price: 0,
          market_price: 0
        },
        {
          imgUrl: '',
          linkPage: '',
          content: '',
          title: '商品名稱',
          id: '',
          price: 0,
          market_price: 0
        },
        {
          imgUrl: '',
          linkPage: '',
          content: '',
          title: '商品名稱',
          id: '',
          price: 0,
          market_price: 0
        },
        {
          imgUrl: '',
          linkPage: '',
          content: '',
          title: '商品名稱',
          id: '',
          price: 0,
          market_price: 0
        }
      ]
    },
    {
      label: '查看更多',
      key: 'moreLink',
      component: function (h, { key }) {
        return <CompPickerLink v-model={this.value[key]} style='margin-top: 7px;' />
      }
    }
  ],
  transformIn: (v) => {
    const { name, base, config, data, list, distributor_id } = v
    return {
      name,
      ...base,
      ...config,
      data,
      list,
      distributor_id
    }
  },
  transformOut: (v) => {
    return pickBy(v, {
      name: 'name',
      base: (v) => {
        return pickBy(v, {
          title: 'title',
          subtitle: 'subtitle',
          padded: 'padded'
        })
      },
      config: (v) => {
        return pickBy(v, {
          brand: 'brand',
          showPrice: 'showPrice',
          style: 'style',
          moreLink: 'moreLink'
        })
      },
      data: 'data'
    })
  }
}
